/**
 * User-facing strings for the worker availability heat map (WorkerHeatMap),
 * Prompt #498 (D5 rebuild).
 *
 * English only: web-admin has no i18n mechanism (no i18n library, no
 * translation files, no language switch, no per-user UI language; see
 * RateWorkerModal.js's note and the #498 report). The approved label was
 * specified for 6 languages; that needs a product decision before any i18n
 * system exists here. Every heat-map string lives in this one module so it
 * can be localised later without touching the component.
 */

/** Approved label (Tammy, #498). */
export const HEAT_MAP_TITLE = 'Areas with 5+ available workers';

/** Shown whenever no area qualifies (also for non-active jobs). */
export const HEAT_MAP_EMPTY = 'No areas with 5+ available workers yet';

export const HEAT_MAP_LOADING = 'Loading worker availability…';
export const HEAT_MAP_LOAD_ERROR = 'Failed to load worker availability.';
export const HEAT_MAP_BREAKDOWN = 'Area Breakdown';
export const HEAT_MAP_JOB_LOCATION = 'Job Location';

/** "within 30 mi of Houston" */
export const heatMapWithin = (miles, city) => `within ${miles} mi of ${city}`;

/**
 * "5-9 workers" for a banded area/total; the plain number for an older
 * response without a band ("6 workers", "1 worker").
 */
export function heatMapWorkersLabel(band, count) {
  if (typeof band === 'string' && band) return `${band} workers`;
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? 'worker' : 'workers'}`;
}
